module.exports = __webpack_public_path__ + "static/media/Bound.4cc0d212.jpeg";